import { ModelElement, NewReaction } from '@/types/models';

export function mapReactionToModelElement(reaction: NewReaction): ModelElement {
  return {
    id: reaction.id,
    name: reaction.name,
    map: reaction.map,
    elementId: reaction.elementId,
    references: reaction.references,
    z: reaction.z,
    notes: reaction.notes,
    visibilityLevel: reaction.visibilityLevel,
    sboTerm: reaction.sboTerm,
  } as ModelElement;
}
